class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
(function () {
  var SHIP_THRESHOLD = 3000; // $30 in cents

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateSavingsBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var notif = document.getElementById('cart-notification');
        if (!notif) return;
        var links = notif.querySelector('.cart-notification__links');
        if (!links) return;
        var existing = notif.querySelector('.cn-savings');

        var hasDiscount = cart.total_discount > 0;
        var hasFreeShip = cart.total_price >= SHIP_THRESHOLD;
        var msg = '';

                if (hasDiscount && hasFreeShip) {
          msg = "You're saving <span class=\"cn-savings__amt\">" + formatMoney(cart.total_discount) + "</span> and qualify for <span class=\"cn-savings__ship\">FREE SHIPPING</span> \u2014 check out now";
        } else if (hasDiscount) {
          msg = "You're saving <span class=\"cn-savings__amt\">" + formatMoney(cart.total_discount) + "</span> \u2014 check out now";
        } else if (hasFreeShip) {
          msg = "You qualify for <span class=\"cn-savings__ship\">FREE SHIPPING</span> \u2014 check out now";
        }

        if (msg) {
                   if (existing) {
            existing.innerHTML = msg;
          } else {
            var badge = document.createElement('p');
            badge.className = 'cn-savings';
            badge.innerHTML = msg;
            links.parentNode.insertBefore(badge, links);
          }
        } else if (existing) {
          existing.remove();
        }
      })
      .catch(function () {});
  }

  var target = document.getElementById('cart-notification');
  if (target) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && target.classList.contains('active')) {
          updateSavingsBadge();
        }
      });
    });
    observer.observe(target, { attributes: true });
  }
})();